import styled from 'styled-components/macro'
import { BREAKPOINTS } from '../GlobalStyles'

export const Skills = () => {
  return (
    <Wrapper>
      <div className='section-inner skills'>
        <h2 className='heading'>
          [ <b>skills</b> ]
        </h2>
        <h3>Full Stack Development & UX/UI Design</h3>
        <div className='text'>
          <p>
            I specialize in crafting intuitive, high-performance front-ends and robust back-ends, seamlessly blending UX/UI design with engineering. My strong communication and organizational skills ensure clean, maintainable code and smooth collaboration.
          </p>
        </div>
        <div className='skill-groups'>
          <div className='group'>
            <p className='title'>Frontend</p>
            <ul>
              <li>HTML5</li>
              <li>CSS3 / SCSS</li>
              <li>Styled Components</li>
              <li>JavaScript / TypeScript</li>
              <li>React / React Native</li>
              <li>React Query</li>
              <li>Redux</li>
              <li>Storybook</li>
            </ul>
          </div>
          <div className='group'>
            <p className='title'>Backend</p>
            <ul>
              <li>Node.js / Express</li>
              <li>Prisma ORM</li>
              <li>RESTful APIs</li>
              <li>MongoDB</li>
              <li>MySQL</li>
              <li>PostgreSQL</li>
            </ul>
          </div>
          <div className='group'>
            <p className='title'>DevOps & Cloud</p>
            <ul>
              <li>AWS (Lambda, S3, RDS, etc.)</li>
              <li>Docker</li>
              <li>GitHub Actions (CI/CD)</li>
            </ul>
          </div>
          <div className='group'>
            <p className='title'>Tools & Testing</p>
            <ul>
              <li>Git / GitHub</li>
              <li>ESLint / Prettier</li>
              <li>Jest / Vitest</li>
              <li>Storybook</li>
              <li>Figma / Adobe XD / Canva</li>
            </ul>
          </div>
          <div className='group'>
            <p className='title'>Languages</p>
            <ul>
              <li>English (native)</li>
              <li>American Sign Language (fluent)</li>
              <li>Hungarian</li>
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background: #f2f2f2;
  .skill-groups {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    gap: 30px;
    .group {
      background: #fff;
      color: #1a1a1a;
      padding: 20px;
      border-radius: 15px;
      .title {
        margin-bottom: 10px;
        font-size: 1.5rem;
        font-weight: bold;
      }
      ul {
        li {
          margin: 10px 0;
        }
      }
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.tablet}) {
    .skill-groups {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: normal;
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.desktop}) {
    .skill-groups {
      width: 800px;
      gap: 40px;
    }
  }
`
